import React, {useEffect, useState} from "react";
import {find} from 'lodash'
import {FormattedMessage} from "react-intl";
import {Button, Dropdown, Form, Input, Table} from 'semantic-ui-react';
import Slider from 'rc-slider';
import {getCategory} from '../../redux/actions';

import 'rc-slider/assets/index.css';

// noinspection JSUnresolvedVariable
const createSliderWithTooltip = Slider.createSliderWithTooltip;

// noinspection JSUnresolvedVariable
const Range = createSliderWithTooltip(Slider.Range);

export const Filters = ({search, pagination, setSearch, setSubcategory, category, subcategory, city_id}) => {

    const subcategory_id = subcategory && subcategory.id ? subcategory.id : 0;
    const subsub = search.subsub || 0;

    const [catSel, setCatSel] = useState(subcategory_id);
    const [subCatSel, setSubCatSel] = useState(subsub);
    const [filters, setFilters] = useState(search);
    const [options, setOptions] = useState([]);
    const [subcategories, setSubcategories] = useState([]);
    const [catText, setCatText] = useState(' ');
    const [subCatText, setSubCatText] = useState(' ');

    const resetForm = () => {

        setCatSel(0);
        setSubCatSel(0);

        setSubcategory({});

        setFilters({
            q: ''
        });

        setSearch({
            category_id: category.id,
            page: 1
        });

        window.location.hash = '';
    };

    const id = category && category.id ? category.id : 0;
    const name = category ? category.name : '';
    const main = 1;

    const fetchRows = async (parent_id) => {

        if (!main || parent_id <= 0) {

            return;
        }

        const res = await getCategory('index', {
            parent_id,
            city_id
        });

        let rows = [];

        await res.data.map((option, i) => {

            rows.push({
                key: option.id.toString(),
                text: option.name,
                slug: option.slug,
                childs: option.child_count,
                //value: `${option.id}|${option.slug}|${option.name}|${option.child_count}`
                value: option.id.toString(),
            });

        });

        return rows;
    };

    useEffect(() => {

        const fetchData = async () => {

            const rows = await fetchRows(id);

            if (rows) {

                const text = await rows.filter(o => {
                    return o.key === catSel;
                });

                if (text.length > 0) {
                    await setCatText(text[0].text);
                }
            }

            await setOptions(rows);
        };

        // noinspection JSIgnoredPromiseFromCall
        fetchData();

    }, [id]);

    // console.log('filters category', category);
    // console.log('filters subcategory', subcategory);
    // console.log('filters subcategory_id', subcategory_id);

    useEffect(() => {

        const fetchData = async () => {

            const rows = await fetchRows(subcategory_id);

            if (rows) {

                const text = await rows.filter(o => {
                    return o.key === subCatSel;
                });

                if (text.length > 0) {
                    await setSubCatText(text[0].text);
                }
            }

            await setSubcategories(rows);
        };

        // noinspection JSIgnoredPromiseFromCall
        fetchData();

    }, [subcategory_id]);

    return (
        <Form onSubmit={() => setSearch({...filters, category_id: search.category_id, page: 1})}>
            <Table stackable basic={'very'} className={'table-filters'}>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell
                            colSpan={3}
                            textAlign={'center'}
                            verticalAlign={'middle'}
                        >
                            {name}
                        </Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {/*<Table.Row>*/}
                    {/*    <Table.Cell width={'4'}><FormattedMessage id="Tipo"/>:</Table.Cell>*/}
                    {/*    <Table.Cell width={'12'}>123</Table.Cell>*/}
                    {/*</Table.Row>*/}
                    {/*<Table.Row>*/}
                    {/*    <Table.Cell>*/}
                    {/*        <FormattedMessage id="Localização"/>:*/}
                    {/*    </Table.Cell>*/}
                    {/*    <Table.Cell width={8}>*/}
                    {/*        <Input*/}
                    {/*            fluid*/}
                    {/*            value={filters.address ? filters.address : ''}*/}
                    {/*            onChange={(e, {value}) => setFilters({...filters, address: value})}*/}
                    {/*        />*/}
                    {/*    </Table.Cell>*/}
                    {/*    <Table.Cell with={4}>*/}
                    {/*        <Checkbox*/}
                    {/*            disabled={true}*/}
                    {/*            label={{children: <FormattedMessage id="Próximo a min"/>}}*/}
                    {/*        />*/}
                    {/*    </Table.Cell>*/}
                    {/*</Table.Row>*/}
                    {
                        main && category.child_count > 0 ? <Table.Row>
                            <Table.Cell>
                                <FormattedMessage id="Categoria"/>:
                            </Table.Cell>
                            <Table.Cell>
                                <Dropdown
                                    // placeholder={placeholder}
                                    // multiple
                                    text={catText}
                                    search
                                    selection
                                    options={options}
                                    selectOnBlur={false}
                                    fluid
                                    value={catSel}
                                    selectOnNavigation={false}
                                    wrapSelection={false}
                                    // defaultSelectedLabel={false}
                                    onChange={
                                        (e, {value}) => {

                                            const option = find(options, (o) => o.key === value)

                                            setSearch({
                                                category_id: value,
                                                page: 1,
                                                category: 1,
                                                child_count: option['childs']
                                            });

                                            setSubcategory({
                                                id: value,
                                                child_count: option['childs']
                                            });

                                            setCatSel(value)
                                        }
                                    }
                                />
                            </Table.Cell>
                        </Table.Row> : null
                    }
                    {
                        subcategory && subcategory.child_count > 0 ? <Table.Row>
                            <Table.Cell>
                                <FormattedMessage id="Subcategoria"/>:
                            </Table.Cell>
                            <Table.Cell>
                                <Dropdown
                                    // placeholder={placeholder}
                                    text={subCatText}
                                    search
                                    selection
                                    options={subcategories}
                                    selectOnBlur={false}
                                    selectOnNavigation={false}
                                    wrapSelection={false}
                                    value={subCatSel}
                                    fluid
                                    onChange={
                                        (e, {value}) => {

                                            setSearch({
                                                category_id: value,
                                                page: 1,
                                                subcategory: 1
                                            });

                                            setSubCatSel(value);
                                        }
                                    }
                                />
                            </Table.Cell>
                        </Table.Row> : null
                    }
                    <Table.Row>
                        <Table.Cell>
                            <FormattedMessage id="Palavra-chave"/>:
                        </Table.Cell>
                        <Table.Cell colSpan={2}>
                            <Input
                                fluid
                                value={filters.q || ''}
                                onChange={(e, {value}) => setFilters({...filters, q: value})}
                                autoFocus
                            />
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell width={'4'}>
                            <FormattedMessage id="Faixa de preço"/>:
                        </Table.Cell>
                        <Table.Cell width={'12'} colSpan={2}>
                            <Range
                                min={0}
                                max={100}
                                step={20}
                                tipFormatter={value => `R$ ${value}`}
                                onChange={(price) => setFilters({...filters, price})}
                            />
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell colspan={2}>
                            <Button
                                content={<FormattedMessage id="Limpar filtros"/>}
                                type={'reset'}
                                onClick={resetForm}
                            />
                            <Button
                                primary
                                content={<FormattedMessage id="Pesquisar"/>}
                            />
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell colspan={2} textAlign={'right'}>
                            {
                                (pagination.current_page && pagination.page_count > 1) &&
                                <>
                                    <FormattedMessage id="Página"/> {` ${pagination.current_page} `}
                                    <FormattedMessage id="de"/> {` ${pagination.page_count}`}
                                </>
                            }
                        </Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
        </Form>
    );
};
